<template>
  <div class="mall-shop-header">
    <div class="mall-shop-header__icon-button" @click="$emit('menu-click', 'home')">
      <img src="@/assets/mall/icn_home_line.svg" alt="마이페이지 홈" />
    </div>
    <div class="mall-shop-header__icons">
      <div class="mall-shop-header__icon-button" @click="$emit('menu-click', 'cart')">
        <img src="@/assets/mall/icn_shopping_line.svg" alt="장바구니" />
      </div>
      <div class="mall-shop-header__icon-button" @click="$emit('menu-click', 'history')">
        <img src="@/assets/mall/icn_document_line.svg" alt="이용내역" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MallShopHeader',
}
</script>

<style scoped>
.mall-shop-header {
  display: flex;
  height: 64px;
  padding: 0 16px;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  background: #FFF;
}

.mall-shop-header__icons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mall-shop-header__icon-button {
  display: flex;
  padding: 4px;
  border-radius: 8px;
  cursor: pointer;
}

.mall-shop-header__icon-button img {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallShopHeader.vue